module.exports = __webpack_public_path__ + "static/media/new-vendor.e7f03a02.svg";